import { render, staticRenderFns } from "./SamtekModal.vue?vue&type=template&id=abb398a6&lang=pug"
import script from "./SamtekModal.vue?vue&type=script&lang=js"
export * from "./SamtekModal.vue?vue&type=script&lang=js"
import style0 from "./SamtekModal.vue?vue&type=style&index=0&id=abb398a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports